import StoresControl from './StoresControl';

export class StoresConsortiumControl extends StoresControl {
    constructor() {
        const options = {
            name: 'StoresConsortium',
            context: 'LAYER_STORES_CONSORTIUM',
        };

        super(options);
    }

    static getInstance() {
        if (!StoresConsortiumControl._instance) {
            StoresConsortiumControl._instance = new StoresConsortiumControl();
        }

        return StoresConsortiumControl._instance;
    }
}

export default StoresConsortiumControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/StoresConsortiumControl.js